// EQUIPMENT
export const EQUIPMENT = 'EQUIPMENT';
export const equipment = 'Equipment';

// FOCUS AREA
export const FOCUS_AREA = 'FOCUS AREA';
export const focusArea = 'Focus area';
